module.exports = __webpack_public_path__ + "static/media/arrival-pin.8f00ade0.svg";